// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__DQd-w","col":"Table_col__1zIot","fulfillmentStatus":"Table_fulfillmentStatus__BrbiI","emailCol":"Table_emailCol__2YtiI"};